import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

import icon1 from "../images/Timeline/icon1.png";
import icon2 from "../images/Timeline/icon2.png";
import icon3 from "../images/Timeline/icon3.png";
import icon4 from "../images/Timeline/icon4.png";

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#87ddda",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#87ddda",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#87ddda",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#87ddda",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#87ddda",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  objectFit: "cover",
  ...(ownerState.active && {
    border: "3px solid #000000",
    padding: "1em",
    background: "#87ddda",
  }),
  ...(ownerState.completed && {
    border: "1px solid #000000",
    padding: "1em",
    background: "#87ddda",
  }),
}));

function DeliveryStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: (
      <img
        src={icon1}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    2: (
      <img
        src={icon2}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    3: (
      <img
        src={icon3}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    4: (
      <img
        src={icon4}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

DeliveryStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

function PickupStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: (
      <img
        src={icon1}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    2: (
      <img
        src={icon2}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    3: (
      <img
        src={icon3}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    4: (
      <img
        src={icon4}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

PickupStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

function CancelStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: (
      <img
        src={icon1}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
    2: (
      <img
        src={icon2}
        alt="creme-n-crisp-order-icon"
        className="timeline_logo"
      />
    ),
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

CancelStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const stepDeliveryCase = [
  "New Order",
  "Preparing",
  "Out for delivery",
  "Completed",
];
const stepCancelCase = ["New Order", "Cancel"];
const stepPickupCase = [
  "New Order",
  "Preparing",
  "Ready for pickup",
  "Completed",
];

const OrderTimeLine = ({ isDeliveryOrder, orderStatus }) => {
  return (
    <Stack sx={{ width: "100%" }} spacing={4}>
      <Stepper
        alternativeLabel
        activeStep={
          orderStatus === "Ordered"
            ? 1
            : orderStatus === "Cancelled" ||
              orderStatus === "Accepted" ||
              orderStatus === "Preparing"
            ? 2
            : orderStatus === "Ready for Pickup" ||
              orderStatus === "Out for delivery"
            ? 3
            : 4
        }
        connector={<ColorlibConnector />}
      >
        {isDeliveryOrder && orderStatus !== "Cancelled"
          ? stepDeliveryCase.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={DeliveryStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))
          : !isDeliveryOrder && orderStatus !== "Cancelled"
          ? stepPickupCase.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={PickupStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))
          : stepCancelCase.map((label) => (
              <Step key={label}>
                <StepLabel StepIconComponent={CancelStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))}
      </Stepper>
    </Stack>
  );
};

export default OrderTimeLine;
